var _style, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E8BF62;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_15"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84.2,
    y: 84.2,
    transform: "matrix(0.9641 -0.2656 0.2656 0.9641 -58.7992 77.1891)",
    width: 343.6,
    height: 343.6
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_14"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84.2,
    y: 84.2,
    transform: "matrix(0.4939 -0.8695 0.8695 0.4939 -93.0369 352.1554)",
    width: 343.6,
    height: 343.6
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M247,263.4c7-17.9,10.3-27.6,8-36.1c-2.6-9.4-10.8-12.8-20.7-10.1c-8,2.2-16.8,8.4-23.3,17.2l-6.3-23 c5.2-6.4,13.4-13.3,26-16.8c22.1-6.1,42.9,2.6,48.7,23.6c3.4,12.5,0.6,25.8-6.7,44.4l-8.5,21.5l0.2,0.3l34.9-9.6l5.9,21.5 l-79.6,21.9l-0.2-0.3L247,263.4z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar2);
export default __webpack_public_path__ + "static/media/star_2.122baa40b181ebf22f17813a2c156fb0.svg";
export { ForwardRef as ReactComponent };